var map = {
	"./client-bentara.jpg": 71,
	"./client-egs.png": 72,
	"./client-petrosea.png": 73,
	"./client1.jpg": 74,
	"./client2.jpg": 75,
	"./client3.jpg": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients ^\.\/.*$
// module id = 220
// module chunks = 1